/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';

export default class StudentDetail extends Transformer {
  /**
   * Method used to transform a jobs to full-calendar representation
   *
   * @param student Job
   *
   * @returns {Object} The transformed account
   */
  static fetch(student) {
    return {
      id: student.id,
      firstName: student.first_name,
      lastName: student.last_name,
      shortName: student.short_name,
      gender: student.gender,
      school: (student.schools && student.schools.length !== 0 && student.schools[0].study_field) ? student.schools[0].study_field.title : null,
      studies: student.studies,
      phone: student.phone,
      email: student.email,
      commentUnique: student.comment_unique,
      threeAdjectives: student.three_qualifications,
      kpi: student.kpi,
      countJobsDone: student.kpi.count_jobs_done,
      geoPools: student.geo_pools,
      mainPicture: student.main_picture ? student.main_picture : null,
      pictureHostess: student.picture_hostess ? student.picture_hostess : null,
      pictureHostessFull: student.picture_hostess_full ? student.picture_hostess_full : null,
      birthdayDate: student.birthday_date,
      feedbackScoreForCurrentCustomer: student.feedback_score_for_current_customer,
      jobCountForCurrentCustomer: student.job_count_for_current_customer,
      lastJobDateForCurrentCustomer: student.last_job_date_for_current_customer,
      lastTenFeedbacks: student.last_ten_feedbacks,
      lastCustomerFeedback: student.last_customer_feedback,
      softSkillsRatedByCustomer: student.soft_skills_rated_by_customer,
    };
  }
}
